import {
  AfterViewInit,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import { membershipAgreeValidator } from 'src/app/shared/directives/fill-together.directive';
import { GuestForm } from '../../../../../../concierge-app/shop-view-booking/booking-details/models/guest-form';
import { FormControlOf } from '../../../../../utils/form-utils';
import { NavigationService } from '../../../../nav/navigation.service';
import {NgClass, NgIf, NgTemplateOutlet} from "@angular/common";
import {TranslocoModule} from "@ngneat/transloco";

@Component({
    selector: 'app-promotion-pal',
    templateUrl: './promotion.component.html',
    styleUrl: './promotion.component.scss',
    imports: [
        NgClass,
        TranslocoModule,
        NgTemplateOutlet,
        NgIf,
        ReactiveFormsModule,
    ]
})
export class PromotionComponent implements AfterViewInit {
  @Input() referrerMandatoryInputEnabled: boolean = false;
  @Input() public projectedContent: TemplateRef<any> | undefined;
  @Input() public form!: FormGroup<FormControlOf<GuestForm>>;

  constructor(public navService: NavigationService) {}

  onAgreeClick($event: unknown): void {
    const currentValue = this.form.controls.isMemberTncAgreed.value;
    this.form.controls.isMemberTncAgreed.patchValue(!currentValue);
  }

  ngAfterViewInit(): void {
    this.form.addValidators(
      membershipAgreeValidator(
        'userReferrerMembershipNumber',
        'isMemberTncAgreed',
      ),
    );
  }
}
